/*
 * @Author: 15708496481 15708496481@163.com
 * @Date: 2022-03-29 10:13:55
 * @LastEditors: 15708496481 15708496481@163.com
 * @LastEditTime: 2022-05-17 14:32:27
 * @FilePath: \zhaoshengbao\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: 15708496481 15708496481@163.com
 * @Date: 2022-03-29 10:13:55
 * @LastEditors: 15708496481 15708496481@163.com
 * @LastEditTime: 2022-05-17 08:34:27
 * @FilePath: \zhaoshengbao\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import Router from "vue-router";

// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(Router);


const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  //	mode:'history',
  routes: [
    // {
    //   path: "/",
    //   redirect: "/video"
    // },
    {
      path: "/",
      // redirect: "/tips"
      redirect: "/video"
    },
    {
      path: "/appAgreement",
      name: "appAgreement",
      // component: resolve => require(["../components/consultation.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/appAgreement.vue")),
          "appAgreement"
        ),
      meta: {
        title: "用户协议",
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "/ebook",
      name: "ebook",
      // component: resolve => require(["../components/consultation.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/ebook.vue")),
          "ebook"
        ),
      meta: {
        title: "招生指南",
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "/orgList",
      name: "orgList",
      // component: resolve => require(["../components/consultation.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/orgList.vue")),
          "orgList"
        ),
      meta: {
        title: "院校",
        keepAlive: true,
        isBack: false
      }
    },

    {
      path: "/myGkKnow",
      name: "myGkKnow",
      // component: resolve => require(["../components/myGkKnow.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/myGkKnow.vue")),
          "myGkKnow"
        ),
      meta: {
        title: "高考资讯"
      }
    },

    {
      path: "/eventoff",
      name: "eventoff",
      // component: resolve => require(["../components/myGkKnow.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/eventoff.vue")),
          "myGkKnow"
        ),
      meta: {
        title: "线下活动"
      }
    },
    {
      path: "/eventoffDetail",
      name: "eventoffDetail",
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/eventoffDetail.vue")),
          "myGkKnow"
        ),
      meta: {
        title: "线下活动详情"
      }
    },
    {
      path: "/consult",
      name: "consult",
      // component: resolve => require(["../components/myGkKnow.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/consult.vue")),
          "myGkKnow"
        ),
      meta: {
        title: "高校咨询群"
      }
    },
    {
      path: "/consultDetail",
      name: "consultDetail",
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/consultDetail.vue")),
          "myGkKnow"
        ),
      meta: {
        title: "高校咨询群详情"
      }
    },
    {
      path: "/myGkMes",
      name: "myGkMes",
      // component: resolve => require(["../components/myGkMes.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/myGkMes.vue")),
          "myGkMes"
        ),
      meta: {
        title: "招生指南"
      }
    },
    {
      path: "/recruitDetail",
      name: "recruitDetail",
      // component: resolve =>require(["../components/recruitDetail.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/recruitDetail.vue")),
          "recruitDetail"
        ),
      meta: {
        title: "指南详情"
      }
    },

    {
      path: "/video",
      name: "video",
      // component: resolve => require(["../components/video.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/video.vue")),
          "video"
        ),
      meta: {
        title: "宣讲",
        keepAlive: true,
        isBack: false
      }
    },

    {
      path: "/testFont",
      name: "testFont",
      // component: resolve => require(["../components/video.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/testFont.vue")),
          "video"
        ),
      meta: {
        title: "宣讲",
        keepAlive: true,
        isBack: false
      }
    },

    {
      path: "/zhuanDetails",
      name: "zhuanDetails",
      // component: resolve => require(["../components/video.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/zhuanDetails.vue")),
          "zhuanDetails"
        ),
      meta: {
        title: "全部专场",
        keepAlive: true,
        isBack: false
      }
    },

    {
      path: "/activityList",
      name: "activityList",
      // component: resolve =>
      //   require(["../components/activityList.vue"], resolve),

      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/activityList.vue")),
          "activityList"
        ),
      meta: {
        title: "线下宣传",
        keepAlive: true,
        isBack: false
      }
    },

    {
      path: "/advList",
      name: "advList",
      // component: resolve => require(["../components/advList.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/advList.vue")),
          "advList"
        ),
      meta: {
        title: "专场活动",
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "/promotionDetail",
      name: "promotionDetail",
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/promotionDetail.vue")),
          "promotionDetail"
        ),
      meta: {
        title: "推荐详情",
        keepAlive: false,
        isBack: false
      }
    },
    // 特殊专场活动---好大学活动
    {
      path: "/goodUAList",
      name: "goodUAList",
      // component: resolve => require(["../components/advList.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/goodUAList.vue")),
          "goodUAList"
        ),
      meta: {
        title: "专场活动",
        keepAlive: true,
        isBack: false
      }
    },

    {
      path: "/ebookSetList",
      name: "ebookSetList",
      // component: resolve => require(["../components/advList.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/ebookSetList.vue")),
          "ebookSetList"
        ),
      meta: {
        title: "招生指南合集",
        keepAlive: true,
        isBack: false
      }
    },

    {
      path: "/video/dist/:id",
      name: "videoDist",
      // component: resolve => require(["../components/videoDist.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/videoDist.vue")),
          "videoDist"
        ),
      meta: {
        title: "宣讲筛选",
        keepAlive: true
      }
    },

    {
      path: "/specailVideos",
      name: "specailVideos",
      // component: resolve =>
      //   require(["../components/specailVideos.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/specailVideos.vue")),
          "specailVideos"
        ),
      meta: {
        title: "专题"
      }
    },
    {
      path: "/message",
      name: "message",
      // component: resolve => require(["../components/message.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/message.vue")),
          "message"
        ),
      meta: {
        title: "消息中心"
      }
    },
    {
      path: "/my",
      name: "my",
      // component: resolve => require(["../components/my.vue"], resolve),
      component: resolve =>
        require.ensure([], () => resolve(require("@/components/my.vue")), "my"),
      meta: {
        title: "个人中心"
      }
    },
    {
      path: "/secretMsg",
      name: "secretMsg",
      // component: resolve => require(["../components/secretMsg.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/secretMsg.vue")),
          "secretMsg"
        ),
      meta: {
        title: "私信"
      }
    },
    {
      path: "/cooperSch",
      name: "cooperSch",
      // component: resolve => require(["../components/cooperSch.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/cooperSch.vue")),
          "cooperSch"
        ),
      meta: {
        title: "合作高校"
      }
    },
    {
      path: "/orgDetail",
      name: "orgDetail",
      // component: resolve => require(["../components/orgDetail.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/orgDetail.vue")),
          "orgDetail"
        ),
      meta: {
        title: "高校详情"
      }
    },
    {
      path: "/myInvite",
      name: "myInvite",
      // component: resolve => require(["../components/myInvite.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/myInvite.vue")),
          "myInvite"
        ),
      meta: {
        title: "观看邀请"
      }
    },
    {
      path: "/inviteVideo",
      name: "inviteVideo",
      // component: resolve => require(["../components/inviteVideo.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/inviteVideo.vue")),
          "inviteVideo"
        ),
      meta: {
        title: "邀请详情"
      }
    },
    {
      path: "/aboutUs",
      name: "aboutUs",
      // component: resolve => require(["../components/aboutUs.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/aboutUs.vue")),
          "aboutUs"
        ),
      meta: {
        title: "关于我们"
      }
    },
    {
      path: "/feedback",
      name: "feedback",
      // component: resolve => require(["../components/feedback.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/feedback.vue")),
          "feedback"
        ),
      meta: {
        title: "问题反馈"
      }
    },
    {
      path: "/orgCenter",
      name: "orgCenter",
      // component: resolve => require(["../components/orgCenter.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/orgCenter.vue")),
          "orgCenter"
        ),
      meta: {
        title: "机构中心",
        isBack: false
      }
    },
    {
      path: "/consulationDetail",
      name: "consulationDetail",
      // component: resolve =>
      //   require(["../components/consulationDetail.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/consulationDetail.vue")),
          "consulationDetail"
        ),
      meta: {
        title: "资讯详情"
      }
    },
    {
      path: "/videoNow",
      name: "videoNow",
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/videoNow.vue")),
          "videoNow"
        ),
      meta: {
        title: "今日宣讲"
      }
    },
    // {
    //   path: "/videoCalendar",
    //   name: "videoCalendar",
    //   component: resolve =>
    //     require.ensure(
    //       [],
    //       () => resolve(require("@/components/videoCalendar.vue")),
    //       "videoCalendar"
    //     ),
    //   meta: { title: "今日宣讲" }
    // },

    {
      path: "/subscribe",
      name: "subscribe",
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/subscribe.vue")),
          "subscribe"
        ),
      meta: {
        title: "订阅"
      }
    },
    {
      path: "/videoDetail",
      name: "videoDetail",
      // component: resolve => require(["../components/videoDetail.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/videoDetail.vue")),
          "videoDetail"
        ),
      meta: {
        title: "宣讲详情"
      }
    },
    // 马甲宣讲详情
    {
      path: "/majia",
      name: "majia",
      // component: resolve => require(["../components/videoDetail.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/majia.vue")),
          "majia"
        ),
      meta: {
        title: "宣讲详情"
      }
    },
    {
      path: "/browseRecords",
      name: "browseRecords",
      // component: resolve =>
      //   require(["../components/browseRecords.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/browseRecords.vue")),
          "browseRecords"
        ),
      meta: {
        title: "报名记录"
      }
    },
    {
      path: "/myCollect",
      name: "myCollect",
      // component: resolve => require(["../components/myCollect.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/myCollect.vue")),
          "myCollect"
        ),
      meta: {
        title: "我的收藏"
      }
    },
    {
      path: "/myShopping",
      name: "myShopping",
      // component: resolve => require(["../components/myShopping.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/myShopping.vue")),
          "myShopping"
        ),
      meta: {
        title: "已购课程"
      }
    },
    {
      path: "/consulationSearch",
      name: "consulationSearch",
      // component: resolve =>
      //   require(["../components/consulationSearch.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/consulationSearch.vue")),
          "consulationSearch"
        ),
      meta: {
        title: "图文搜索"
      }
    },
    {
      path: "/videoSearch",
      name: "videoSearch",
      // component: resolve => require(["../components/videoSearch.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/videoSearch.vue")),
          "videoSearch"
        ),
      meta: {
        title: "宣讲搜索"
      }
    },
    {
      path: "/searchAll",
      name: "searchAll",
      // component: resolve => require(["../components/searchAll.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/searchAll.vue")),
          "searchAll"
        ),
      meta: {
        title: "搜索"
      }
    },
    {
      path: "/myRecommend",
      name: "myRecommend",
      // component: resolve => require(["../components/myRecommend.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/myRecommend.vue")),
          "myRecommend"
        ),
      meta: {
        title: "个人资料"
      }
    },
    {
      path: "/pcVideo",
      name: "pcVideo",
      // component: resolve => require(["../components/pcVideo.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/pcVideo.vue")),
          "pcVideo"
        ),
      meta: {
        title: "",
        keepAlive: false,
      }
    },
    {
      path: "/userTranslation",
      name: "userTranslation",
      // component: resolve =>
      //   require(["../components/userTranslation.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/userTranslation.vue")),
          "userTranslation"
        ),
      meta: {
        title: "用户协议"
      }
    },

    //

    {
      path: "/activity",
      name: "activity",
      // component: resolve => require(["../components/activity.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/activity.vue")),
          "activity"
        ),
      meta: {
        title: "活动"
      }
    },

    {
      path: "/oauth",
      name: "oauth",
      // component: resolve => require(["../components/oauth.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/oauth.vue")),
          "oauth"
        ),
      meta: {
        title: "授权网页登录"
      }
    },
    {
      path: "/mPdf",
      name: "mPdf",
      // component: resolve => require(["../components/oauth.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/mPdf.vue")),
          "mPdf"
        ),
      meta: {
        title: "招生指南"
      }
    },
    {
      path: "/tips",
      name: "tips",
      // component: resolve => require(["../components/video.vue"], resolve),
      component: resolve =>
        require.ensure(
          [],
          () => resolve(require("@/components/tips.vue")),
          "tips"
        ),
      meta: {
        title: "提示",
        keepAlive: true,
        isBack: false
      }
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js